module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-338.e494b21.woff2";